import React from "react";
import { Box } from "@mui/material";
import AnalyticalMetrics from "./AnalyticalMetrics";
import FormulationsMetrics from "./FormulationsMetrics";
import WorkRequestMetrics from "./WorkRequestMetrics";
import { GlobalTabCollection, StyledTab } from "../../../styles.js";

const Reporting = ({ ...props }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <AnalyticalMetrics />;
      }
      case 1: {
        return <FormulationsMetrics />;
      }
      case 2: {
        return <WorkRequestMetrics />;
      }

      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <>
      <div>
        <Box sx={{ bgcolor: "#fff" }}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='Analytical Metrics' />
            <StyledTab label='Blends Metrics' />
            <StyledTab label='Work Request Metrics' />
          </GlobalTabCollection>
          <Box sx={{ p: 2 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default Reporting;